import { Typography, makeStyles } from "@material-ui/core"
import { FC, useState } from "react"
import { useUser } from "../../hooks/useUser"
import { ComponentHeaderHeight } from "../../utils/constants"
import { colors } from "../../utils/theme"
import AddButton from "../molecules/AddButton"
import { HeaderHeight } from "../molecules/Header"
import InAppResourcesTable from "../molecules/InAppResourceTable"
import TechniquesAndInterventionsTable from "../molecules/TechniquesAndInterventionsTable"
import { InAppResourceDialog } from "../organisms/InAppResourceDialog"

const useStyles = makeStyles((theme) => ({
  myTechs: {
    padding: theme.spacing(3),
    paddingTop: HeaderHeight + theme.spacing(3),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    backgroundColor: colors.neutral.white,
    flex: 1,
  },
  header: {
    height: ComponentHeaderHeight,
    maxWidth: 1440,
    margin: "0 auto",
  },
  content: {
    maxWidth: 1440,
    margin: "0 auto",
  },
  title: {
    color: colors.neutral.denim,
  },
  subtitle: {
    color: colors.neutral.denim,
    fontWeight: 300,
  },
  inAppContentLabel: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
    gap: theme.spacing(3),
  },
}))

const MyTechniquesAndInterventions: FC = () => {
  const { user } = useUser()
  const classes = useStyles()
  const [openInAppResourceDialog, setOpenInAppResourceDialog] =
    useState<boolean>(false)
  return (
    <>
      <div className={classes.myTechs}>
        <div className={classes.content}>
          <div className={classes.header}>
            <Typography variant="h1" component="h1" className={classes.title}>
              {user?.organizations?.[0].name}
            </Typography>
          </div>
        </div>
        <div className={classes.content}>
          <TechniquesAndInterventionsTable />
          <div className={classes.inAppContentLabel}>
            <Typography
              variant="h3"
              component="h1"
              className={classes.subtitle}
            >
              In App Resources
            </Typography>
            <AddButton onClick={() => setOpenInAppResourceDialog(true)} />
          </div>
          <InAppResourcesTable />
        </div>
        <InAppResourceDialog
          newResource={true}
          onClose={() => setOpenInAppResourceDialog(false)}
          open={openInAppResourceDialog}
        />
      </div>
    </>
  )
}

export default MyTechniquesAndInterventions
